import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import CustomDatePicker from '../elements/CustomDatePicker'
import InputRowPaymentMethod from '../components/InputRowPaymentMethod'

const options = {
    postUrl: '/api/postCancelService/mobile',
    success: 'Your service has been scheduled for cancellation.'
}
const state = {
    date: '',
    serviceId: ''
}

class CancelMobileServiceForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    min28Days (date) {
        const today = new Date()
        today.setDate(today.getDate() + 28)

        return today < date
    }

    minDate () {
        const today = new Date()
        today.setDate(today.getDate() + 28)

        return today
    }

    handleChange (values) {
        this.props.setDynamicValues(values)
        this.props.handleChange(values.date)
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRowReadOnly
                    label='My phone number'
                    value={this.props.mobile}
                />
                <InputRowReadOnly
                    label='My contract end date'
                    value={this.props.endDate}
                />
                <InputRowPaymentMethod />
                <CustomDatePicker
                    label='Cancel my service'
                    name='date'
                    value={this.props.values.date}
                    errors={this.props.errors}
                    handleChange={this.handleChange.bind(this)}
                    filterDate={this.min28Days.bind(this)}
                    minDate={this.minDate()}
                >
                    <small>(28 days notice required)</small>
                </CustomDatePicker>
                <InputRowReadOnly
                    label='Early termination fee'
                    value={this.props.fee === null ? 'Enter date above' : this.props.fee}
                />

                {this.props.children}
                {this.props.errors}

                <div className='mt-4'>
                    <p className='color-red'><small>
                        Your service will be cancelled at midnight AEST on the date you select above. You will continue to incur plan access fees and excess usage charges for your service until this time.
                                             </small>
                    </p>
                    <p><small>
                        IMPORTANT: As per your Terms & Conditions for this service:<br />
                        12.1 The Customer may cancel the Service at any time by:<br />
                        a. giving Exetel twenty eight (28) days notice (including if the Customer does not wish to continue to use the Service after the end of the Minimum Term of a Fixed-Term Agreement)
                       </small>
                    </p>
                </div>

                <div className='mt-4'>
                    <Button
                        title='Cancel Service'
                        className={this.props.fee === null ? 'disabled' : ''}
                        action={this.props.fee === null ? () => {} : this.props.handleSubmit}
                    />
                </div>
            </form>
        )
    }
}

CancelMobileServiceForm.propTypes = {
    setDynamicValues: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleKeyDown: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    serviceId: PropTypes.number,
    mobile: PropTypes.string,
    endDate: PropTypes.string,
    fee: PropTypes.string,
    errors: PropTypes.object
}

export default FormHOC(CancelMobileServiceForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/CancelMobileServiceForm.js